//Angular
import { Component,ChangeDetectionStrategy, ViewEncapsulation, OnInit, ViewContainerRef, Compiler, Inject, Renderer } from "@angular/core";

//Services
import { ComponentHelperService } from "./../../../services/core/component-helper.service";
import { CmsComponentService } from "./../../../services/cms/cms-component.service";

//Models
import { Company } from "./../../../models/core/company";
import { TranslateService } from "@ngx-translate/core";
import { RoutesService } from "../../../services/core/routes.service";

import { Subscription } from 'rxjs/Subscription';
import { SeoService } from "../../../services/core/seo.service";
import { DOCUMENT } from "@angular/platform-browser";

@Component({
    changeDetection: ChangeDetectionStrategy.Default,
    encapsulation: ViewEncapsulation.Emulated,
    template: ""
})

export class OfflinePageComponent implements OnInit {
    constructor
        (
            private _compiler: Compiler,
            private componentHelper: ComponentHelperService,
            private _elementRef: ViewContainerRef,
            private cmsComponentService: CmsComponentService,
            @Inject('isBrowser') private isBrowser: boolean,
            private seo: SeoService,
            private renderer: Renderer,
            @Inject(DOCUMENT) private document: any
        ) { }

    subManager = new Subscription();

    ngOnInit() {
        let offlinePageData: any;
        let header: any;
        let headDataSub = this.cmsComponentService.getHeaderData().subscribe(result => {
            header = result;
            let SideMenuData = this.cmsComponentService.getSideMenuData().subscribe(result1 => {
                if (result1.Categories) {
                    header.Categories = result1.Categories;

                }
            });
            this.subManager.add(SideMenuData);
        });
        this.subManager.add(headDataSub);
        let offlineSub = this.cmsComponentService.getOfflinePageData().subscribe(result => {

            offlinePageData = result;
            //Creating subcomponent whith the selected template to inject
            let subComponent = this.createSubComponent(offlinePageData,header);

            //injecting created component (OK)
            this.componentHelper.injectComponent(this._compiler, this._elementRef, subComponent);
        });

        this.subManager.add(offlineSub);
    }

    ngOnDestroy() {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        this.subManager.unsubscribe();
    }

    private createSubComponent(pageData: any,header:any) {

        @Component({
            template: pageData.TemplateHtml
        })

        class ChildComponent implements OnInit {
            constructor
                (
                    private translateService: TranslateService,
                    private routesService: RoutesService,
                    @Inject('isBrowser') private isBrowser: boolean
                ) { }

            private company: Company = pageData.Company;

            private pageIsInit: boolean = false;

            private OfflineMessage: string = pageData.OfflineMessage;
            footerData: any = pageData.footerData;
            headerData: any = header;

            ngOnInit() {
            }

            ngAfterViewChecked() {
                if (!this.isBrowser || this.pageIsInit) {
                    return;
                }

                //hiding of loading panel after we get all data we need
                this.routesService.hidePageLoader();
                this.pageIsInit = true;
            }
        }

        return ChildComponent;
    }
}


// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/components/core/sys/offline-page.component.ts